import styled from 'styled-components';

import { sectionWrapperStyle } from 'modules/fleet/section/style';

import GateKeepingSection from './component';

export default styled(GateKeepingSection)`
  ${sectionWrapperStyle}
`;
